var _defs, _path, _g, _g2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 910,
    zoomAndPan: "magnify",
    viewBox: "0 0 682.5 682.499979",
    height: 910,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "de0a3a0eff"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "1c64cec769"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#de0a3a0eff)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -68.25,
    width: 819,
    fill: "#000000",
    y: -68.249998,
    height: 818.999975,
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "8264b5c4d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.148438 0.785156 L 651 0.785156 L 651 611 L 0.148438 611 Z M 0.148438 0.785156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8852b67192"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 652,
    y: 0,
    height: 612
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a31cf86422"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#de0a3a0eff)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -68.25,
    width: 819,
    fill: "#000000",
    y: -68.249998,
    height: 818.999975,
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "00951821ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.351562 1 L 539.476562 1 L 539.476562 563 L 0.351562 563 Z M 0.351562 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b70b4afd66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 540,
    y: 0,
    height: 564
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 69.308594 164.726562 C -162.484375 526.972656 400.851562 826.625 620.648438 478.347656 C 829.378906 147.59375 236.792969 -168.925781 69.308594 164.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1c64cec769)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 14, 22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8852b67192)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8264b5c4d4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5271ff",
    d: "M 55.308594 142.726562 C -176.484375 504.972656 386.851562 804.625 606.648438 456.347656 C 815.378906 125.59375 222.792969 -190.925781 55.308594 142.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a31cf86422)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 68, 50)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b70b4afd66)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#00951821ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5271ff",
    d: "M 227.035156 9.4375 C -148.386719 66.230469 -19.644531 614.808594 339.570312 558.011719 C 680.601562 504.117188 546.191406 -73.449219 227.035156 9.4375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 369.355469 262.238281 L 369.355469 229.558594 C 369.355469 224.683594 369.621094 220.859375 370.015625 218.226562 C 370.410156 215.589844 371.464844 212.953125 373.179688 210.320312 C 374.761719 207.683594 377.394531 205.96875 380.953125 204.917969 C 384.511719 203.863281 389.386719 203.464844 395.316406 203.464844 L 427.996094 203.464844 L 427.996094 138.105469 L 375.8125 138.105469 C 345.636719 138.105469 323.894531 145.222656 310.71875 159.585938 C 297.539062 173.949219 290.953125 195.03125 290.953125 222.96875 L 290.953125 262.238281 L 251.816406 262.238281 L 251.816406 327.597656 L 290.953125 327.597656 L 290.953125 517.089844 L 369.355469 517.089844 L 369.355469 327.597656 L 421.539062 327.597656 L 428.390625 262.238281 Z M 369.355469 262.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/Fb.2821e03a4224a5a818a5a74d01566d87.svg";
export { ForwardRef as ReactComponent };